import React, { ReactElement, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { RiAlertFill } from 'react-icons/ri';
import { useNavigate } from 'react-router-dom';
import { useAlarmServiceDeleteAlarmMutation } from '../../../api/enhanced/enhancedAlarms';
import Modal from '../../../components/modal/modal';
import FormErrorLabel from '../../../components/form/formErrorLabel';
import LoadingSpinner from '../../../components/spinner/loadingSpinner';

interface DeleteAlarmModalProps {
  isOpen: boolean;
  buildingId: string;
  groupId: string;
  alarmId?: string;
  sensorType:
    | 'SENSOR_TYPE_UNSPECIFIED'
    | 'SENSOR_TYPE_TRAP'
    | 'SENSOR_TYPE_TEMP'
    | 'SENSOR_TYPE_CARBON_DIOXIDE'
    | 'SENSOR_TYPE_DOOR'
    | 'SENSOR_TYPE_HUMIDITY';
  closeHandler: () => void;
}

function DeleteAlarmModal({
  isOpen,
  alarmId,
  buildingId,
  groupId,
  closeHandler,
  sensorType
}: DeleteAlarmModalProps): ReactElement {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [deleteAlarm, { isSuccess, isError, isLoading, reset }] =
    useAlarmServiceDeleteAlarmMutation();

  useEffect(() => {
    if (isSuccess) {
      reset();
      closeHandler();
    }
  }, [isSuccess, reset, navigate, closeHandler]);

  const close = (): void => {
    closeHandler();
    reset();
  };

  return (
    <Modal
      isOpen={isOpen}
      closeHandler={() => {
        close();
      }}
      title={t('modals.deleteAlarm.title')}
    >
      <div className="flex flex-col w-full">
        <div className="w-full flex flex-col">
          {isError ? (
            <FormErrorLabel
              className="mb-3"
              icon={<RiAlertFill size={20} />}
              label={t('modals.deleteAlarm.error')}
            />
          ) : null}
        </div>
        <p>{t('modals.deleteAlarm.message')}</p>
        <div className="flex items-end flex-col w-full mt-5">
          {!isLoading && alarmId != null ? (
            <button
              className=" rounded-lg shadow-md w-36 h-10 bg-red-500 text-white"
              type="button"
              onClick={() => {
                deleteAlarm({
                  groupId,
                  buildingId,
                  alarmId,
                  sensorType
                });
              }}
            >
              {t('modals.deleteAlarm.deleteBtn')}
            </button>
          ) : (
            <div className="rounded-lg shadow-md w-36  h-10  p-4 bg-red-500 text-white flex justify-center items-center">
              <LoadingSpinner />
            </div>
          )}
        </div>
      </div>
    </Modal>
  );
}

export default DeleteAlarmModal;
